import type React from 'react';
import { CodeSmall } from '@/components/shared/typography/CodeText';
import { withTruncation } from '@/components/shared/hocs/withTruncation';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

type TruncatedContentProps = {
  children: React.ReactNode;
  className?: string;
  tooltipContent?: React.ReactNode;
};

export const TruncatedCodeSmall = withTruncation<
  TruncatedContentProps & {
    isTruncated: boolean;
    truncationRef: React.RefCallback<HTMLElement>;
    checkTruncation: () => void;
  }
>(
  ({
    truncationRef,
    isTruncated,
    checkTruncation,
    children,
    className,
    tooltipContent,
  }) => {
    const content = (
      <CodeSmall
        ref={truncationRef}
        background
        as="span"
        className={cn('block w-full truncate', className)}
        onMouseEnter={checkTruncation}
        onFocus={checkTruncation}
      >
        {children}
      </CodeSmall>
    );

    if (!isTruncated) {
      return content;
    }

    return (
      <Tooltip>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent side="top" className="max-w-sm">
          {tooltipContent ?? children}
        </TooltipContent>
      </Tooltip>
    );
  }
);

export const TruncatedText = withTruncation<
  TruncatedContentProps & {
    isTruncated: boolean;
    truncationRef: React.RefCallback<HTMLElement>;
    checkTruncation: () => void;
  }
>(
  ({
    truncationRef,
    isTruncated,
    checkTruncation,
    children,
    className,
    tooltipContent,
  }) => {
    const content = (
      <span
        ref={truncationRef}
        className={cn('block w-full truncate', className)}
        onMouseEnter={checkTruncation}
        onFocus={checkTruncation}
      >
        {children}
      </span>
    );

    if (!isTruncated) {
      return content;
    }

    return (
      <Tooltip>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent side="top" className="max-w-sm">
          {tooltipContent ?? children}
        </TooltipContent>
      </Tooltip>
    );
  }
);
